import { useState } from 'react';

import { useThemeColors } from '@/settings/handler/settingsStore';
import { PixelContainer } from '@/ui/pixel/PixelContainer';
import { PixelIcon } from '@/ui/pixel/PixelIcon';

export interface PixelPasswordFieldProps {
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  disabled?: boolean;
}

export function PixelPasswordField({
  value,
  onChange,
  autoComplete,
  disabled = false,
}: PixelPasswordFieldProps) {
  const colors = useThemeColors();
  const [visible, setVisible] = useState(false);

  return (
    <PixelContainer
      radius={3}
      pixelScale={2}
      padding="4px 4px 4px 12px"
      backgroundColor={colors.surfaceContainerHighest}
      borderColor={colors.onSurface}
    >
      <div className="flex items-center gap-1">
        <input
          type={visible ? 'text' : 'password'}
          value={value}
          autoComplete={autoComplete}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
          className="min-w-0 flex-1 bg-transparent outline-none"
          style={{
            fontSize: 20,
            color: colors.onSurface,
            lineHeight: 1.2,
            fontFamily: 'inherit',
            border: 'none',
            padding: '6px 0',
          }}
        />
        <button
          type="button"
          aria-label={visible ? 'Hide password' : 'Show password'}
          disabled={disabled}
          onClick={() => setVisible((current) => !current)}
          className="flex h-10 w-10 shrink-0 items-center justify-center disabled:opacity-40"
        >
          <PixelIcon
            name={visible ? 'eye-off' : 'eye'}
            set="pixel_icons"
            size={22}
            color={colors.onSurface}
          />
        </button>
      </div>
    </PixelContainer>
  );
}
